import React from "react";
import { Link as GatsbyLink, GatsbyLinkProps } from "gatsby";
import { usePageContext } from "./PageContext";

export const Link = ({ to, ref, ...rest }) => {
  const { lang } = usePageContext();

  let languagePrefix = "";

  if (lang && lang != "sq") {
    languagePrefix = `/${lang}`;
  }

  return <GatsbyLink {...rest} to={`${languagePrefix}${to}`} />;
};

export default Link;
